import { CircularProgress, MenuItem } from '@mui/material';
import csv from 'csvtojson';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSnackbar } from 'redux/snackbar';
import jschardet from 'jschardet';
import { decodeData } from './helpers/decode-data';

export function FileUploader({
  onPost, onCloseMenuImport,
}) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  async function processCSVFile(file) {
    const reader = new FileReader();
    reader.readAsText(file, 'ISO-8859-1');

    let detectedEncoding;
    const fileData = await new Promise((resolve, reject) => {
      reader.onload = () => {
        detectedEncoding = jschardet.detect(reader.result).encoding;
        const output = reader.result.split(';').join(',');
        resolve(output);
      };
      reader.onerror = () => {
        reject(reader.error);
      };
    });
    const jsonData = await csv().fromString(fileData);
    return {
      jsonData,
      detectedEncoding,
    };
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      onCloseMenuImport();
      return;
    }

    const fileExtension = file.name.split('.').pop();
    if (fileExtension !== 'csv') {
      onCloseMenuImport();
      dispatch(
        setSnackbar(
          true,
          'error',
          'Por favor, selecione um arquivo .csv!',
        ),
      );
      return;
    }

    try {
      setIsLoading(true);
      const { jsonData, detectedEncoding } = await processCSVFile(file);
      if (detectedEncoding.includes('UTF-8')) {
        const decode = decodeData(jsonData);
        await onPost(decode);
        return;
      }

      await onPost(jsonData);
    } catch {
      dispatch(
        setSnackbar(
          true,
          'error',
          'Erro ao processar arquivo!',
        ),
      );
      throw new Error('Erro ao processar arquivo.');
    } finally {
      setIsLoading(false);
      onCloseMenuImport();
    }
  };

  return (
    <label htmlFor="file-upload">
      <MenuItem sx={{ display: 'flex', gap: 1 }}>
        Importar Planilha
        <input
          onChange={handleFileChange}
          accept=".csv"
          type="file"
          id="file-upload"
          style={{ display: 'none' }}
        />
        {isLoading && <CircularProgress size={20} />}
      </MenuItem>
    </label>
  );
}
